export const STRATEGIES_RULES_ENGINE_CONFIG_RESPONSE = {
	'@type': 'ToolsResultBeans',
	'allDataReturned': true,
	'requestId': 'DTTS-time-20210310_16-11-48_539_env-TST_hkey-ttcw02_count-3279',
	'requests': [
		{
			'@type': '_bws.request.FileRequest',
			'apiClient': 'blackrock',
			'requestId': 'DTTS-time-20210310_16-11-48_539_env-TST_hkey-ttcw02_count-3279',
			'requestingApp': 'blk-wealth-services',
			'requestUser': {
				'@type': '_bws.user.SimpleUser',
				'aladdinPerms': {
					'PortfolioBuilder': ['PCS', 'Support', 'Admin', 'IMA', 'View'],
					'geAllocTargetSetup': ['*'],
					'WebUserData': [],
					'BTAP_CollectionAdmin': ['sec10k', 'fhfa', 'cores', 'fed', 'trbv3', 'sec8k', 'trbv2', 'confcall', 'sec10q', 'dj2', 'dj2text'],
					'BTAP_CollectionView': ['sec10k', 'fhfa', 'cores', 'fed', 'trbv3', 'sec8k', 'trbv2', 'confcall', 'sec10q', 'dj2', 'dj2text'],
					'WebToolsPlatform': ['SecuritiesControlEnrichmentData', 'SecuritiesControl'],
					'PortBuilderSec': ['WithholdExpRet']
				},
				'aladdinUserId': 'hmirza',
				'apiClient': 'blackrock',
				'orgCode': 'TST',
				'orgCodeAndAladdinUserId': 'TST.hmirza',
				'secondaryApiClients': ['env_tst', 'org_apg', 'env@tst', 'org@apg'],
				'trackingId': '2468665',
				'userEmail': 'harris.mirza@blackrock.com',
				'userId': 'hmirza',
				'userPlatformId': '2971688'
			},
			'secondaryApiClients': ['env_tst', 'org_apg', 'env@tst', 'org@apg'],
			'timeout': 60,
			'useCache': true,
			'fileTypeNames': ['cma-estimator'],
			'includeAllFiles': true,
			'path': 'bfa',
			'variants': ['strategies-config']
		}
	],
	'success': true,
	'timerLogs': {},
	'totalRequestTime': 0,
	'resultMap': {
		'REPORT': [
			{
				'@type': '_bws.report.ConfigFileData',
				'success': true,
				'typeName': 'cma-estimator',
				'variant': 'strategies-config',
				'data': {
					'@type': 'java.util.LinkedHashMap',
					'maxStrategies': 3,
					'minStrategies': 2,
					'rulesConfigData': [
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'greaterThan',
									'target': 0.35
								},
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'greaterThan',
									'target': 0.35
								},
								{
									'fact': 'subAssetClass.coreBonds',
									'operator': 'greaterThan',
									'target': 0.1
								},
								{
									'fact': 'subAssetClass.usLargeCapStocks',
									'operator': 'greaterThan',
									'target': 0.1
								}
							],
							'conditionType': 'all',
							'output': [
								'enhanceReturns_wholePortfolio_moderate_privateMarkets'
							]
						},
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'greaterThan',
									'target': 0.2
								},
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'lessThan',
									'target': 0.35
								},
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'greaterThan',
									'target': 0.65
								},
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'lessThan',
									'target': 0.8
								},
								{
									'fact': 'subAssetClass.coreBonds',
									'operator': 'greaterThan',
									'target': 0.15
								},
								{
									'fact': 'subAssetClass.usLargeCapStocks',
									'operator': 'greaterThan',
									'target': 0.05
								}
							],
							'conditionType': 'all',
							'output': [
								'enhanceReturns_wholePortfolio_conservative_privateMarkets'
							]
						},
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'greaterThan',
									'target': 0.65
								},
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'lessThan',
									'target': 0.8
								},
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'greaterThan',
									'target': 0.2
								},
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'lessThan',
									'target': 0.35
								},
								{
									'fact': 'subAssetClass.coreBonds',
									'operator': 'greaterThan',
									'target': 0.05
								},
								{
									'fact': 'subAssetClass.usLargeCapStocks',
									'operator': 'greaterThan',
									'target': 0.15
								}
							],
							'conditionType': 'all',
							'output': [
								'enhanceReturns_wholePortfolio_aggressive_privateMarkets'
							]
						},
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'greaterThan',
									'target': 0.4
								},
								{
									'fact': 'subAssetClass.coreBonds',
									'operator': 'greaterThan',
									'target': 0.15
								},
								{
									'fact': 'subAssetClass.creditBonds',
									'operator': 'greaterThan',
									'target': 0.05
								}
							],
							'conditionType': 'all',
							'output': [
								'enhanceReturns_Fixed_Income_a_Private_Alts'
							]
						},
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'greaterThan',
									'target': 0.2
								},
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'lessThan',
									'target': 0.4
								},
								{
									'fact': 'subAssetClass.coreBonds',
									'operator': 'greaterThan',
									'target': 0.075
								},
								{
									'fact': 'subAssetClass.creditBonds',
									'operator': 'greaterThan',
									'target': 0.025
								}
							],
							'conditionType': 'all',
							'output': [
								'enhanceReturns_Fixed_Income_b_Private_Alts'
							]
						},
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'greaterThan',
									'target': 0.4
								},
								{
									'fact': 'subAssetClass.usLargeCapStocks',
									'operator': 'greaterThan',
									'target': 0.2
								}
							],
							'conditionType': 'all',
							'output': [
								'enhanceReturns_Equity_a_Private_LargeCap_Equity'
							]
						},
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'greaterThan',
									'target': 0.2
								},
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'lessThan',
									'target': 0.4
								},
								{
									'fact': 'subAssetClass.usLargeCapStocks',
									'operator': 'greaterThan',
									'target': 0.1
								},
								{
									'fact': ['subAssetClass.usLargeCapStocks', 'subAssetClass.usMidCapStocks', 'subAssetClass.usSmallCapStocks'],
									'factOperator': 'add',
									'operator': 'greaterThan',
									'target': 0.1
								}
							],
							'conditionType': 'all',
							'output': [
								'enhanceReturns_Equity_b_Private_LargeCap_Equity'
							]
						},
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'lessThan',
									'target': 1.0
								},
								{
									'fact': 'acAssetClass.usFixedIncome',
									'operator': 'greaterThan',
									'target': 0.0
								}
							],
							'conditionType': 'all',
							'output': [
								'strategyTwo'
							]
						},
						{
							'conditions': [
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'lessThan',
									'target': 1.0
								},
								{
									'fact': 'acAssetClass.usEquities',
									'operator': 'greaterThan',
									'target': 0.0
								}
							],
							'conditionType': 'all',
							'output': [
								'strategyThree'
							]
						}
					]
				}
			}
		]
	}
};
